SET_PAYMENT_METHODS